import type { paths } from "./schema";

/**
 * Every API path the portal calls, in one place (DECISIONS.md §2.10). Typed against the backend's OpenAPI,
 * so a path that no longer exists fails the build.
 */
export const ENDPOINTS = {
  session: "/v1/auth/session",
  me: "/v1/me",
  notifications: "/v1/me/notifications",
  notificationsReadAll: "/v1/me/notifications/read-all",
  notificationRead: "/v1/me/notifications/{notificationId}/read",
  myBrands: "/v1/vendor/brands",
  invitations: "/v1/vendor/invitations",
  invitationAccept: "/v1/vendor/invitations/{invitationId}/accept",
  invitationDecline: "/v1/vendor/invitations/{invitationId}/decline",
  reportSummary: "/v1/vendor/brands/{brandId}/reports/summary",
  analyticsSummary: "/v1/vendor/brands/{brandId}/analytics/summary",
  analyticsDay: "/v1/vendor/brands/{brandId}/analytics/day",
  analyticsMonth: "/v1/vendor/brands/{brandId}/analytics/month",
  analyticsPlans: "/v1/vendor/brands/{brandId}/analytics/plans",
  dispatchSheet: "/v1/vendor/brands/{brandId}/dispatch",
  dispatchTemplates: "/v1/vendor/brands/{brandId}/dispatch/templates",
  dispatchDispatched: "/v1/vendor/brands/{brandId}/dispatch/dispatched",
  dispatchDelivered: "/v1/vendor/brands/{brandId}/dispatch/delivered",
  mealMissed: "/v1/vendor/brands/{brandId}/meals/{mealId}/missed",
  customerPlans: "/v1/vendor/brands/{brandId}/subscriptions",
  customerPlan: "/v1/vendor/brands/{brandId}/subscriptions/{subscriptionId}",
  customerPlanBonusMeals: "/v1/vendor/brands/{brandId}/subscriptions/{subscriptionId}/bonus-meals",
  customerPlanRemoveMeals: "/v1/vendor/brands/{brandId}/subscriptions/{subscriptionId}/remove-meals",
  customerPlanMealsLeft: "/v1/vendor/brands/{brandId}/subscriptions/{subscriptionId}/meals-left",
  customerPlanMovePlan: "/v1/vendor/brands/{brandId}/subscriptions/{subscriptionId}/move-plan",
  mealLog: "/v1/vendor/brands/{brandId}/meal-log",
  mealLogExport: "/v1/vendor/brands/{brandId}/meal-log/export",
  brandCustomers: "/v1/vendor/brands/{brandId}/customers",
  brandCustomer: "/v1/vendor/brands/{brandId}/customers/{userId}",
  planMenuCopyWeek: "/v1/vendor/brands/{brandId}/plans/{planId}/menu/copy-week",
  reviews: "/v1/vendor/brands/{brandId}/reviews",
  dishes: "/v1/vendor/brands/{brandId}/dishes",
  dish: "/v1/vendor/brands/{brandId}/dishes/{dishId}",
  dishAddons: "/v1/vendor/brands/{brandId}/dishes/{dishId}/addons",
  plans: "/v1/vendor/brands/{brandId}/plans",
  plan: "/v1/vendor/brands/{brandId}/plans/{planId}",
  planOptions: "/v1/vendor/brands/{brandId}/plans/{planId}/options",
  planOption: "/v1/vendor/brands/{brandId}/plans/{planId}/options/{optionId}",
  planMenu: "/v1/vendor/brands/{brandId}/plans/{planId}/menu",
  planMenuDay: "/v1/vendor/brands/{brandId}/plans/{planId}/menu/{date}",
  planMenuApplyTemplate: "/v1/vendor/brands/{brandId}/plans/{planId}/menu/apply-template",
  menuTemplates: "/v1/vendor/brands/{brandId}/menu-templates",
  menuTemplate: "/v1/vendor/brands/{brandId}/menu-templates/{templateId}",
  brandSettings: "/v1/vendor/brands/{brandId}/settings",
  mealSlots: "/v1/vendor/brands/{brandId}/meal-slots",
  mealSlot: "/v1/vendor/brands/{brandId}/meal-slots/{slotId}",
  mealSlotOrder: "/v1/vendor/brands/{brandId}/meal-slots/order",
  promoCodes: "/v1/vendor/brands/{brandId}/promo-codes",
  promoCode: "/v1/vendor/brands/{brandId}/promo-codes/{promoId}",
  team: "/v1/vendor/brands/{brandId}/members",
  teamInvitations: "/v1/vendor/brands/{brandId}/members/invitations",
  teamInvitation: "/v1/vendor/brands/{brandId}/members/invitations/{invitationId}",
  teamMember: "/v1/vendor/brands/{brandId}/members/{userId}",
  holidays: "/v1/vendor/brands/{brandId}/holidays",
  holiday: "/v1/vendor/brands/{brandId}/holidays/{date}",
  brandProfile: "/v1/vendor/brands/{brandId}",
  earnings: "/v1/vendor/brands/{brandId}/earnings",
  payouts: "/v1/vendor/brands/{brandId}/payouts",
  payout: "/v1/vendor/brands/{brandId}/payouts/{payoutId}",
  payoutAccount: "/v1/vendor/brands/{brandId}/payout-account",
} as const satisfies Record<string, keyof paths>;
